import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AddComboPayload, ComboGiftsState, RemoveComboPayload } from "./types";

const initialState: ComboGiftsState = {};

const comboGiftsSlice = createSlice({
  name: "giftsCombo",
  initialState,
  reducers: {
    registerGift: (state, action: PayloadAction<AddComboPayload>) => {
      const currentTime = Date.now();
      const {
        giftId,
        accountId,
        eventId = currentTime.toString(),
      } = action.payload;
      const comboKey = `${giftId}-${accountId}`;
      if (state[comboKey]) {
        state[comboKey].eventIds = [
          ...new Set([...state[comboKey].eventIds, eventId]),
        ];
        state[comboKey].startTime = currentTime;
        state[comboKey].accountId = accountId;
      } else {
        state[comboKey] = {
          eventIds: [eventId],
          comboId: Date.now(),
          startTime: currentTime,
          accountId,
        };
      }
    },

    removeCombo: (state, action: PayloadAction<RemoveComboPayload>) => {
      const { giftId, accountId } = action.payload;
      const comboKey = `${giftId}-${accountId}`;
      if (state[comboKey]) {
        delete state[comboKey];
      }
    },

    resetAllCombos: () => initialState,
  },
});

export const { registerGift, removeCombo, resetAllCombos } =
  comboGiftsSlice.actions;

export const comboGiftsReducer = comboGiftsSlice.reducer;
